<app-attachments-browser
  [attachmentsPath]="attachmentsPath"
  [isTemporaryFiles]="isTemporaryFiles"
  [isReadonly]="isReadonly"
  [canUpload]="(canUploadFiles$ | async) === true"
  [showBreadcrumbs]="false"
  [allowFolders]="false"
  [showStorageCard]="true"
  [storageUsage]="storageUsage$ | async"
  [files]="(files$ | async) ?? null"
  [emptyFileListParam]="emptyFileListParam"
  (uploadedFile)="onUploadFile($event)"
  (deletedUploadedFile)="onDeleteFile($event)"
  (reachedStorageLimit)="onReachedStorageLimit()"
  (fileRename)="renameFile($event.id, $event.name)"
  (fileRemove)="deleteAttachment($event)"
  (fileAction)="handleFileAction($event.file, $event.action)"
></app-attachments-browser>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>
